import {
  call, put, takeLatest, all, fork, join, takeLeading, takeEvery, select,
} from 'redux-saga/effects';
import { authenticationWrapper } from '@services/errorHandlingService';
// import { courseMock } from './__fixtures__/courseMock';
// import { courseMock as cypressMock } from './__fixtures__/courseMockCypress';
// import { hebrewCourseMock } from './__fixtures__/courseMockHebrew';
import VideoMonitorService from '@services/videoMonitorService';
import { visitAll } from '@containers/Admin/containers/ActivityPage/services';
import { closePopUp } from '@containers/App/containers/PopUp/actions';
import { markLessonAsCompleted } from '@containers/Admin/containers/Builder/service/lesson';
import {
  markFeedbackAsSeenFailed,
  markFeedbackAsSeenSucceed,
  setCourses,
  setCoursesFailed,
  TYPES,
} from './actions';
import { getEntityCourses } from './services';
import { setLessonError } from './containers/Lesson/actions';

const useFixtures = process.env.USE_FIXTURES;

export function* callGetCourses() {
  let mock;
  yield authenticationWrapper(
    function* codeBlock() {
      const userId = yield select((state) => state.getIn(['app', 'authentication', 'user', 'id']));
      const res = yield fork(getEntityCourses, userId);
      const courses = useFixtures ? mock : yield join(res);
      yield put(setCourses(courses));
    },
    function* onError() {
      yield put(setCoursesFailed('CONNECTION_ERROR'));
    },
  );
}

function* callMarkFeedback(action) {
  try {
    const { postType, ids } = action;
    const res = yield call(visitAll, postType, ids);
    if (res) {
      yield put(markFeedbackAsSeenSucceed());
      yield put(closePopUp());
    } else {
      yield put(markFeedbackAsSeenFailed());
    }
  } catch (e) {
    yield put(markFeedbackAsSeenFailed());
  }
}

export function* callDisconnectFromMirrorSession() {
  yield fork(VideoMonitorService.disconnectFromMirrorSession);
}

function* callMarkLessonAsCompleted(action) {
  try {
    const id = action.lesson?.id;
    if (!id) return;
    yield call(markLessonAsCompleted, id);
  } catch (e) {
    yield put(setLessonError(e.message));
  }
}

function* watchCallGetCourses() {
  yield takeLatest(TYPES.GET_COURSES, callGetCourses);
}
function* watchCallMarkFeedback() {
  yield takeLatest(TYPES.MARK_FEEDBACK_AS_SEEN, callMarkFeedback);
}
function* watchCallMarkLessonAsCompleted() {
  yield takeLeading(TYPES.MARK_LESSON_AS_COMPLETED, callMarkLessonAsCompleted);
}
export default function* courseSaga() {
  yield all([fork(watchCallGetCourses), fork(watchCallMarkFeedback), fork(watchCallMarkLessonAsCompleted)]);
}
